let currentImageIndex = 0;
let imageUrls = [];

const createLightboxElement = (id) => {
  const lightbox = document.createElement("div");
  lightbox.id = id;
  lightbox.className = "lightbox-modal";
  
  const modalContent = document.createElement("div");
  modalContent.className = "lightbox-modal-content";
  
  const closeBtn = document.createElement("span");
  closeBtn.className = "lightbox-close";
  closeBtn.innerHTML = "&times;";
  
  const imgContainer = document.createElement("div");
  imgContainer.className = "lightbox-image-container";
  
  const img = document.createElement("img");
  img.className = "lightbox-image";
  img.id = `${id}-img`;
  
  const prevArrow = document.createElement("a");
  prevArrow.className = "lightbox-prev";
  prevArrow.innerHTML = "&#10094;";
  
  const nextArrow = document.createElement("a");
  nextArrow.className = "lightbox-next";
  nextArrow.innerHTML = "&#10095;";
  
  const counter = document.createElement("div");
  counter.className = "lightbox-counter";
  counter.id = `${id}-counter`;
  
  const thumbnails = document.createElement("div");
  thumbnails.className = "lightbox-thumbnails";
  thumbnails.id = `${id}-thumbnails`;
  
  imgContainer.appendChild(prevArrow);
  imgContainer.appendChild(img);
  imgContainer.appendChild(nextArrow);
  
  modalContent.appendChild(closeBtn);
  modalContent.appendChild(imgContainer);
  modalContent.appendChild(counter);
  modalContent.appendChild(thumbnails);
  
  lightbox.appendChild(modalContent);
  
  // Event handlers
  closeBtn.onclick = () => lightbox.style.display = "none";
  lightbox.onclick = (e) => {
    if (e.target === lightbox) lightbox.style.display = "none";
  };
  
  prevArrow.onclick = (e) => {
    e.stopPropagation();
    navigateImages(-1, id);
  };
  
  nextArrow.onclick = (e) => {
    e.stopPropagation();
    navigateImages(1, id);
  };
  
  document.body.appendChild(lightbox);
  return lightbox;
};

const navigateImages = (direction, id = "lightbox") => {
  currentImageIndex += direction;
  if (currentImageIndex < 0) currentImageIndex = imageUrls.length - 1;
  if (currentImageIndex >= imageUrls.length) currentImageIndex = 0;
  updateLightboxImage(id);
};

const updateLightboxImage = (id = "lightbox") => {
  const lightboxImg = document.getElementById(`${id}-img`);
  const counter = document.getElementById(`${id}-counter`);
  const thumbnails = document.querySelectorAll(`.${id}-thumbnail`);
  
  if (lightboxImg && imageUrls[currentImageIndex]) {
    lightboxImg.src = imageUrls[currentImageIndex];
    counter.textContent = `${currentImageIndex + 1}/${imageUrls.length}`;
    
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle("active", index === currentImageIndex);
    });
  }
};

export const initLightbox = (id = "lightbox") => {
  if (!document.getElementById(id)) {
    createLightboxElement(id);
  }
};

export const showLightbox = (images, startIndex = 0, id = "lightbox") => {
  currentImageIndex = startIndex;
  imageUrls = images;
  
  const lightbox = document.getElementById(id);
  const lightboxImg = document.getElementById(`${id}-img`);
  const thumbnails = document.getElementById(`${id}-thumbnails`);
  const counter = document.getElementById(`${id}-counter`);
  
  if (lightbox && lightboxImg && imageUrls.length > 0) {
    lightboxImg.src = imageUrls[currentImageIndex];
    counter.textContent = `${currentImageIndex + 1}/${imageUrls.length}`;
    
    // Build thumbnails
    thumbnails.innerHTML = "";
    imageUrls.forEach((thumbUrl, thumbIndex) => {
      const thumb = document.createElement("img");
      thumb.className = `lightbox-thumbnail ${thumbIndex === currentImageIndex ? "active" : ""}`;
      thumb.src = thumbUrl;
      thumb.onclick = (e) => {
        e.stopPropagation();
        currentImageIndex = thumbIndex;
        updateLightboxImage();
      };
      thumbnails.appendChild(thumb);
    });
    
    lightbox.style.display = "block";
  }
};

// Add keyboard support
document.addEventListener('keydown', (e) => {
  const lightbox = document.getElementById("lightbox"); // or your specific ID
  if (lightbox && lightbox.style.display === "block") {
    if (e.key === "ArrowLeft") navigateImages(-1, lightbox.id);
    if (e.key === "ArrowRight") navigateImages(1, lightbox.id);
    if (e.key === "Escape") lightbox.style.display = "none";
  }
});

export const convertGoogleDriveUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      if (parsedUrl.hostname === "drive.google.com") {
        if (url.includes("/file/d/")) {
          const match = url.match(/\/file\/d\/([^/?&]+)/);
          if (match && match[1]) {
            const fileId = match[1];
            return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
          }
        }
        if (parsedUrl.pathname === "/open") {
          const fileId = parsedUrl.searchParams.get("id");
          if (fileId) {
            return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
          }
        }
      }
      return url;
    } catch (error) {
      console.error("Error converting Google Drive URL:", error);
      return url;
    }
  };